import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp, FISlogin
} from '../../services/AuthService';
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
// import { BrowserRouter } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import {
    useHistory, HashRouter as Router, useNavigate,
    Route, Switch, withRouter, Link, Redirect
} from 'react-router-dom';

// export const navigate = useNavigate();

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';


// const SuperAdminDashboard = lazy(() => import('../../jsx/components/AppsMenu/MasterManagment/SuperAdminDashboard'));

// <Router basename='/fis/foods/SuperAdminDashboard'>
//     <Switch>
//         <Route path='/fis/foods/SuperAdminDashboard' component={SuperAdminDashboard} />
//     </Switch>
// </Router>



export function signupAction(email, password, history) {
    return (dispatch) => {
        signUp(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    history,
                );
                dispatch(confirmedSignupAction(response.data));

                history.push('/dashboard');

            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

export function logout(history) {
    localStorage.clear();
    history.push('/login');
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, history) {

    console.log("history", history)
    console.log("history", password)

    return (dispatch) => {
        FISlogin(email, password)
            .then((response) => {
                console.log("response", response)
                console.log("response", response.data.status)
                if (response.data.status === true) {
                    
                    localStorage.setItem('userDetails', JSON.stringify(response.data));
                    // if (response.data.firstLoginStatus == "Y" || response.data.firstLoginStatus == null) {
                    //     window.location.href = "/fis/foods/page-forgot-password";
                    // } else  
                    if (response.data.role == "MANAGER") {
                        // history.push('/dashboard');
                        // return <Redirect to='/fis/foods/dashboard' />

                        window.location.replace('#/dashboard');
                        window.location.reload(true);

                        // history.push('#/fis/foods/dashboard');
                        // /fis/foods/login#/dashboard
                        // window.location.href = "/dashboard";
                        // return <Redirect to="/dashboard" />
                    } else if (response.data.role == "ADMIN") {
                        // console.log("history", history);
                        // history.go('/fis/foods/SuperAdminDashboard');
                        // history.push('#/SuperAdminDashboard');

                        window.location.replace('#/SuperAdminDashboard');
                        window.location.reload(true);


                        // <Redirect to={"/SuperAdminDashboard"} />
                        // window.location.href = "/SuperAdminDashboard";
                        // return <Redirect to="/SuperAdminDashboard" />
                        // <Route path="/fis/foods/SuperAdminDashboard" />

                        // <Redirect
                        //     to={{
                        //         pathname: "/SuperAdminDashboard"
                        //     }}
                        // />

                        // <Link to='/fis/foods/SuperAdminDashboard' />
                        // return <Redirect to='/fis/foods/SuperAdminDashboard' />
                        // history.go('/fis/foods/SuperAdminDashboard');
                        // this.props.history.push('/SuperAdminDashboard');
                        // <BrowserRouter forceRefresh={true} basename='/fis/foods/SuperAdminDashboard' > </BrowserRouter>
                        // this.props.history.push("/fis/foods/SuperAdminDashboard")
                        // window.location.href = "/fis/foods/SuperAdminDashboard";

                    } else if (response.data.role == "STAFF") {
                        // return <Redirect to='/fis/foods/EcommerceMnt' />
                        // window.location.href = "/EcommerceMnt";
                        // return <Redirect to="/EcommerceMnt" />
                        window.location.replace('#/EcommerceMnt');
                        window.location.reload(true);
                        // history.push('/EcommerceMnt');
                    }
                } else {
                    // const errorMessage = formatError();
                    // dispatch(loginFailedAction(errorMessage));
                    swal("Error", "Invalid Credentials", "error");
                    // alert("Invalid Mail ID, Password")
                }
                // saveTokenInLocalStorage(response.data);
                // runLogoutTimer(
                //     dispatch,
                //     response.data.expiresIn * 1000,
                //     history,
                // );
                // dispatch(loginConfirmedAction(response.data));
                // history.push('/dashboard');

            })
            .catch((error) => {
                console.log(error);
                // window.location.replace = "/";
                swal("Error", "Error", "error");
                // alert("error");
                // const errorMessage = formatError(error.response.data);
                // dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {

    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {

    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {

    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {

    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {

    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
